/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const FlightBlueIcon = ({ cls }: { cls?: string }) => {
  return (
    <svg
      width="190"
      height="306"
      viewBox="0 0 190 306"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M169.589 218.533L169.589 219.033L170.089 219.033L178.5 219.033L178.5 277.478C178.5 285.501 171.967 292 163.91 292L127.733 292C127.464 274.232 112.907 259.909 95 259.909C77.0931 259.909 62.5358 274.232 62.2673 292L26.0897 292C18.0326 292 11.5 285.501 11.5 277.478L11.5 219.033L21.2851 219.033L21.7851 219.033L21.7851 218.533L21.7851 207.563L21.7851 207.063L21.2851 207.063L11.5 207.063L11.5 33.5215C11.5 25.5065 18.0328 19 26.0897 19L62.2673 19C62.5356 36.7749 77.0856 51.0981 95 51.0981C112.914 51.0981 127.464 36.7749 127.733 19L163.91 19C171.967 19 178.5 25.5065 178.5 33.5215L178.5 207.063L170.089 207.063L169.589 207.063L169.589 207.563L169.589 218.533ZM42.0459 218.533L42.0459 219.033L42.5459 219.033L63.7994 219.033L64.2994 219.033L64.2994 218.533L64.2994 207.563L64.2994 207.063L63.7994 207.063L42.5459 207.063L42.0459 207.063L42.0459 207.563L42.0459 218.533ZM84.5602 218.533L84.5602 219.033L85.0602 219.033L106.314 219.033L106.814 219.033L106.814 218.533L106.814 207.563L106.814 207.063L106.314 207.063L85.0602 207.063L84.5602 207.063L84.5602 207.563L84.5602 218.533ZM127.074 218.533L127.074 219.033L127.574 219.033L148.835 219.033L149.335 219.033L149.335 218.533L149.335 207.563L149.335 207.063L148.835 207.063L127.574 207.063L127.074 207.063L127.074 207.563L127.074 218.533Z"
        fill="url(#paint0_linear_4001_34880)"
        stroke="url(#paint1_linear_4001_34880)"
      />

      <path
        d="M100.148 179.361C98.592 180.744 96.5178 181.781 94.2708 181.781C89.6038 181.781 85.9739 177.979 83.8997 174.521C81.8254 170.892 80.4426 166.225 80.4426 162.768L80.4426 145.31L51.4036 128.716L50.0208 128.024L50.0208 126.469L50.0208 109.875L50.0208 106.072L53.4778 107.109L80.4426 114.888L80.4426 107.109L70.4172 99.5039L69.3801 98.8125L69.3801 97.4297L69.3801 86.3672L69.3801 82.7373L72.6643 83.6016L94.2708 88.96L115.704 83.6016L119.161 82.7373L119.161 86.3672L119.161 97.4297L119.161 98.8125L117.951 99.5039L108.099 107.109L108.099 114.888L134.891 107.109L138.521 106.072L138.521 109.875L138.521 126.469L138.521 128.024L136.965 128.716L108.099 145.31L108.099 162.768C108.099 166.397 106.543 170.892 104.296 174.521C103.259 176.423 101.876 178.151 100.148 179.361ZM99.6292 171.583C101.531 168.645 102.568 165.015 102.568 162.768L102.568 143.754L102.568 142.198L103.95 141.334L132.99 124.74L132.99 113.505L106.025 121.11L102.568 122.147L102.568 118.518L102.568 105.727L102.568 104.344L103.605 103.479L113.63 96.0469L113.63 89.8242L94.7893 94.4912L94.2708 94.6641L93.5793 94.4912L74.9114 89.8242L74.9114 96.0469L84.7639 103.479L85.9739 104.344L85.9739 105.727L85.9739 118.518L85.9739 122.147L82.344 121.11L55.552 113.505L55.552 124.74L84.4182 141.334L85.9739 142.198L85.9739 143.754L85.9739 162.768C85.9739 165.015 86.8381 168.645 88.7395 171.583C90.6409 174.694 92.5422 176.25 94.2708 176.25C94.9622 176.25 95.8264 175.904 96.6907 175.04C97.7278 174.349 98.7649 173.139 99.6292 171.583Z"
        fill="#F0F0F0"
      />

      <defs>
        <linearGradient
          id="paint0_linear_4001_34880"
          x1="179"
          y1="18.5"
          x2="-65.1969"
          y2="168.227"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#DCF3F4" stop-opacity="0.8" />

          <stop offset="0.3" stop-color="#72D0D7" stop-opacity="0.6" />

          <stop offset="1" stop-color="#DCF3F4" stop-opacity="0.7" />
        </linearGradient>

        <linearGradient
          id="paint1_linear_4001_34880"
          x1="179"
          y1="18.5"
          x2="-65.1969"
          y2="168.227"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EEF9FA" stop-opacity="0.5" />

          <stop offset="0.3" stop-color="#21C0C9" stop-opacity="0.6" />

          <stop offset="1" stop-color="#EEF9FA" stop-opacity="0.7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default FlightBlueIcon;
